import { render, staticRenderFns } from "./CodeExampleBody.vue?vue&type=template&id=6bfc0784&lang=pug"
import script from "./CodeExampleBody.vue?vue&type=script&lang=ts"
export * from "./CodeExampleBody.vue?vue&type=script&lang=ts"
import style0 from "./CodeExampleBody.vue?vue&type=style&index=0&id=6bfc0784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports